var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex h-full items-center justify-center",class:[_vm.colorType === 'main' ? _vm.classStyles['text-main_color-600'] : _vm.classStyles['text-secondary_color-600'], _vm.styles.btn_simple],attrs:{"disabled":_vm.load}},[_vm._t("default"),_vm._v(" "),(_vm.load)?_c('my-loader'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }